import React from "react";
import { compose, lifecycle } from 'recompose'

import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from "react-google-maps";

import {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';


import CustomOverlayView from "components/CustomOverlayView/CustomOverlayView.jsx";



const RegularMap = 
  compose(
      lifecycle({
        componentDidUpdate(){

          const bounds = new window.google.maps.LatLngBounds();

          const projection = this.state.overlayViewRef.getProjection();

          const paddings = {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5,
          };

          this.props.markers.forEach(marker => {

            bounds.extend(marker.props.position);

            let markerLatLng = new window.google.maps.LatLng(marker.props.position.lat, marker.props.position.lng);
            let markerPixelCoordinates = projection.fromLatLngToDivPixel(markerLatLng);

            bounds.extend(
              projection.fromDivPixelToLatLng({
                x: markerPixelCoordinates.x - paddings.left,
                y: markerPixelCoordinates.y - paddings.top
              })
            );
            bounds.extend(
              projection.fromDivPixelToLatLng({
                x: markerPixelCoordinates.x + paddings.right,
                y: markerPixelCoordinates.y + paddings.bottom
              })
            );


            this.state.ref.fitBounds(bounds);

          })



        },
        componentWillMount() {
          //const refs = {};


          this.setState({
            //bounds: null,
            //center: {
            //  lat: 41.9, lng: -87.624
            //},
            //markers: [],
            onMapMounted: ref => {
              this.setState({ref});
            },

            onOverlayViewMounted: overlayViewRef => {
              this.setState({overlayViewRef});
            },            
            
          })
        },
      }),
    withScriptjs,
    withGoogleMap
  )(props => (
      <GoogleMap
        ref={props.onMapMounted}
        defaultZoom={8}
        defaultCenter={props.defaultCenter}
        defaultOptions={{
          scrollwheel: false
        }}
      >
        <CustomOverlayView
          ref={props.onOverlayViewMounted}
          position={props.defaultCenter}
        ><div></div>
        </CustomOverlayView>
          {props.markers}
      </GoogleMap>
    )
  );

class LocationsMap extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      markers: [],
    };

  }

  componentDidUpdate(prevProps){

    this.props.locations.map((location, key)=>{
        let address = [location.addressStreet1, location.addressStreet2, location.addressCity, location.addressProvince, location.addressCountry].join(" "); 
        
        if(prevProps.locations[key]){
          let prevAddress = [prevProps.locations[key].addressStreet1, prevProps.locations[key].addressStreet2, prevProps.locations[key].addressCity, prevProps.locations[key].addressProvince, prevProps.locations[key].addressCountry].join(" "); 
          if(address===prevAddress){
            return false;
          }
        }
        
        geocodeByAddress(address)
          .then(results => getLatLng(results[0]))
          .then(latLng => {
            let markers = this.state.markers;
            markers.push(<Marker key={markers.length+1} position={latLng} />);
            this.setState({markers});
          })
          .catch(error => console.error('Error', error));
          return false;
      });    

  }

  render() {
  	return (
      <RegularMap
        googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyA2TE-ks3DUffic8hlC_mH54-0wlOc8pBY"
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: `280px`, borderRadius: "6px", overflow: "hidden" }} />}
        mapElement={<div style={{ height: `100%` }} />}
        markers={this.state.markers}
        defaultCenter={{ lat: 40.748817, lng: -73.985428 }}
      />        
    );
  }
}

export default LocationsMap;



// WEBPACK FOOTER //
// ./src/components/LocationsMap/LocationsMap.jsx